// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"BookingSearchFooter_wrapper__2i2rA","total":"BookingSearchFooter_total__-WJeR"};